(function () {
  var ORIGIN = window.location.origin;

  function buildSrc(id, start, muted) {
    var p = [
      'autoplay=1',
      'mute=' + (muted ? '1' : '0'),
      'loop=1',
      'playlist=' + id,   // BẮT BUỘC: không có dòng này thì loop không chạy
      'playsinline=1',
      'rel=0',
      'enablejsapi=1',
      'origin=' + encodeURIComponent(ORIGIN)
    ];
    if (start && parseInt(start, 10) > 0) p.push('start=' + parseInt(start, 10));
    return 'https://www.youtube-nocookie.com/embed/' + id + '?' + p.join('&');
  }

  function cmd(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: [] }), '*'
    );
  }

  function loadVideo(el, muted) {
    // Đã nạp rồi thì chỉ phát tiếp
    if (el.dataset.ytLoaded === 'true') {
      cmd(el.querySelector('iframe'), 'playVideo');
      return;
    }
    var iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = buildSrc(el.dataset.ytId, el.dataset.ytStart, muted);
    el.appendChild(iframe);
    el.dataset.ytLoaded = 'true';
    el.classList.add('is-loaded');
  }

  function init() {
    var embeds = document.querySelectorAll('.yt-embed');
    if (!embeds.length) return;

    // Bấm poster = phát KÈM TIẾNG (vì có user gesture)
    embeds.forEach(function (el) {
      var poster = el.querySelector('.yt-embed__poster');
      if (poster) poster.addEventListener('click', function () { loadVideo(el, false); });
    });

    if (!('IntersectionObserver' in window)) return; // fallback: chỉ còn click

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          loadVideo(el, true);              // cuộn tới → autoplay MUTED
        } else if (el.dataset.ytLoaded === 'true') {
          cmd(el.querySelector('iframe'), 'pauseVideo'); // ra khỏi màn hình → tạm dừng
        }
      });
    }, { threshold: 0.5 });

    embeds.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();